import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = {
  key: 0,
  class: "auth-info"
}
const _hoisted_3 = { class: "info-item" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "info-item" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = {
  key: 1,
  class: "auth-form"
}
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = { class: "form-item" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { ref, onMounted } from "vue";
import { showToast } from 'vant';
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();

const isAuthenticated = ref(false);
const realName = ref('');
const idNumber = ref('');

const form = ref({
  realName: '',
  idCard: '',
  phoneNumber: ''
});

onMounted(() => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    isAuthenticated.value = userInfo.authentication === 1;

    if (isAuthenticated.value) {
      realName.value = userInfo.realName || '';
      idNumber.value = userInfo.idCard || '';
    }
  } catch (error) {
    console.error('获取用户信息失败:', error);
  }
});

// 身份证号码验证
const validateIdCard = (idCard: string) => {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return reg.test(idCard);
};

// 手机号码验证
const validatePhone = (phone: string) => {
  const reg = /^1[3-9]\d{9}$/;
  return reg.test(phone);
};

const handleSubmit = () => {
  // 验证姓名
  if (!form.value.realName.trim()) {
    showToast('请输入真实姓名');
    return;
  }

  // 验证姓名长度
  if (form.value.realName.length < 2) {
    showToast('姓名长度不能少于2个字符');
    return;
  }

  // 验证身份证
  if (!form.value.idCard) {
    showToast('请输入身份证号码');
    return;
  }
  if (!validateIdCard(form.value.idCard)) {
    showToast('请输入正确的身份证号码');
    return;
  }

  // 验证手机号
  if (!form.value.phoneNumber) {
    showToast('请输入手机号码');
    return;
  }
  if (!validatePhone(form.value.phoneNumber)) {
    showToast('请输入正确的手机号码');
    return;
  }

  // 验证通过，可以提交表单
  submitForm();
};

const submitForm = async () => {
  try {
    // TODO: 跳转设置密码
    router.push({
      path: '/SetPwd',
      query: {
        data: JSON.stringify(form.value)
      }
    })
    console.log('提交表单:', form.value);

  } catch (error) {
    console.error('提交失败:', error);
    showToast('认证失败，请重试');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "实名认证" }),
    _createElementVNode("div", _hoisted_1, [
      (isAuthenticated.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, "真实姓名", -1)),
              _createElementVNode("div", _hoisted_4, _toDisplayString(realName.value), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "身份证号码", -1)),
              _createElementVNode("div", _hoisted_6, _toDisplayString(idNumber.value), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, "真实姓名", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.realName) = $event)),
                placeholder: "请输入您的姓名"
              }, null, 512), [
                [_vModelText, form.value.realName]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "身份证号码", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.idCard) = $event)),
                placeholder: "请输入您的身份证号码"
              }, null, 512), [
                [_vModelText, form.value.idCard]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "手机号码", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.phoneNumber) = $event)),
                placeholder: "请输入您的手机号码"
              }, null, 512), [
                [_vModelText, form.value.phoneNumber]
              ])
            ]),
            _createElementVNode("div", {
              class: "submit-btn",
              onClick: handleSubmit
            }, "实名认证")
          ]))
    ])
  ], 64))
}
}

})